module.exports = __webpack_public_path__ + "static/img/030 3.efb915ab.jpg";